import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private http: HttpClient) {}

  getUserInfo(): Observable<UserDetails> {
    const url = `${environment.apiHost}/users/current`;
    return this.http.get<UserDetails>(url);
  }

  getUserOffices(): Observable<any[]> {
    const url = `${environment.apiHost}/users/offices`;
    return this.http.get<any[]>(url);
  }

  setOfficeForUser(officeId: string): Observable<boolean> {
    const url = `${environment.apiHost}/users/current/office`;
    return this.http.post<boolean>(url, { officeId });
  }

  updateCurrentUserDetails(
    officeId: string,
    language: string | null
  ): Observable<number> {
    const url = `${environment.apiHost}/users/current`;
    return this.http.post<number>(url, {
      officeId,
      language,
    });
  }
}

export class UserDetails {
  userId?: string;
  fullName?: string;
  officeId?: string;
  language?: string;
  offices: Office[] = [];
  email?: string;
  signaturePicture?: string;
  signatureTitle?: string;
  trackGpsLocation?: boolean;
  trackingFrequencyPlugged?: number;
  trackingFrequencyUnplugged?: number;
  trackingHighPrecision?: boolean;
  defaultCar?: number;
}

export class Office {
  token?: string;
  name?: string;
  id!: number;
  language?: string;
}
